import type { CityImage } from '@optionway/models';

/**
 * Shared as query options rather than as a `defineQuery` composable on purpose: the pinia-colada Nuxt plugin
 * only awaits `useQuery` calls made from a component, and the hero image is the LCP of the home page.
 */
export const cityImageOptions = defineQueryOptions((input: { code: string; apiUrl?: string }) => ({
  key: ['city-image', input.code],
  query: () => $fetch<CityImage>(`${input.apiUrl}/search/images/${input.code}`),
  enabled: !!input.code && !!input.apiUrl,
  staleTime: 1000 * 60 * 60,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
}));
